import { Component, OnInit } from '@angular/core';
import { ResourceService } from '@services/index.service';
import { ResponseDataBase } from '@interfaces/index.interface';
import { AppConstants } from '../../../../appConstants';

@Component({
  selector: 'clear-cache-page',
  templateUrl: './clear-cache.page.html'
})
export class ClearCachePage implements OnInit {

  alert;

  constructor(public _resourceService: ResourceService) {
    // this.clearCache();
  }

  clearCache() {
    this._resourceService.clearCache().subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS != AppConstants.STATUS.ERROR) {
        this.alert = 'CACHE_CLEARED'
      } else {
      }
      this._resourceService.loading = false;
    });
  }

  ngOnInit() {
  }

}
